module.exports = __webpack_public_path__ + "img/photo-0025.8bf1fc11.jpg";